exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "gw-form-address{display:block;margin-bottom:24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./resources/assets/js/common/forms/address/address.scss
// module id = 54JV
// module chunks = 1